import { gql } from '@apollo/client';

export const GET_GLOBAL_PREF = gql`
  query GetGlobalBrowserPref($user_id: uuid!, $org_id: uuid!) {
    user_notification_preferences(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        event_type: { _is_null: true }
        notification_event_type_id: { _is_null: true }
      }
      limit: 1
    ) {
      id
      browser_enabled
    }
  }
`;

export const UPDATE_GLOBAL_PREF = gql`
  mutation UpdateGlobalBrowserPref($id: uuid!, $browser_enabled: Boolean!) {
    update_user_notification_preferences_by_pk(
      pk_columns: { id: $id }
      _set: { browser_enabled: $browser_enabled, updated_at: "now()" }
    ) {
      id
      browser_enabled
    }
  }
`;

export const INSERT_GLOBAL_PREF = gql`
  mutation InsertGlobalBrowserPref(
    $user_id: uuid!
    $org_id: uuid!
    $browser_enabled: Boolean!
  ) {
    insert_user_notification_preferences_one(
      object: {
        user_id: $user_id
        org_id: $org_id
        browser_enabled: $browser_enabled
      }
    ) {
      id
      browser_enabled
    }
  }
`;

export const GET_EVENT_TYPES = gql`
  query GetEventTypes {
    notification_event_types(order_by: { order_number: asc }) {
      id
      event_type
      description
      event_header
    }
  }
`;

export const GET_USER_PREFERENCES = gql`
  query GetUserPreferences($user_id: uuid!, $org_id: uuid!) {
    user_notification_preferences(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        event_type: { _is_null: false }
      }
    ) {
      event_type
      browser_enabled
    }
  }
`;

export const GET_ALL_PREFS_FOR_USER = gql`
  query GetAllPrefsForUser($user_id: uuid!, $org_id: uuid!) {
    user_notification_preferences(
      where: { user_id: { _eq: $user_id }, org_id: { _eq: $org_id } }
    ) {
      event_type
      browser_enabled
    }
  }
`;

export const GET_ASSIGNED_PREF = gql`
  query GetAssignedBrowserPref(
    $user_id: uuid!
    $org_id: uuid!
    $event_type: String!
  ) {
    user_notification_preferences(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        event_type: { _eq: $event_type }
      }
      limit: 1
    ) {
      browser_enabled
    }
  }
`;

export const UPDATE_PREF = gql`
  mutation UpdatePref(
    $user_id: uuid!
    $org_id: uuid!
    $event_type: String!
    $browser_enabled: Boolean!
  ) {
    update_user_notification_preferences(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        event_type: { _eq: $event_type }
      }
      _set: { browser_enabled: $browser_enabled, updated_at: "now()" }
    ) {
      affected_rows
    }
  }
`;

export const INSERT_PREF = gql`
  mutation InsertPref(
    $user_id: uuid!
    $org_id: uuid!
    $event_type: String!
    $browser_enabled: Boolean!
  ) {
    insert_user_notification_preferences_one(
      object: {
        user_id: $user_id
        org_id: $org_id
        event_type: $event_type
        browser_enabled: $browser_enabled
      }
    ) {
      id
      browser_enabled
    }
  }
`;

export const INSERT_NOTIFICATION = gql`
  mutation InsertNotification(
    $user_id: uuid!
    $org_id: uuid!
    $project_id: uuid!
    $event_type: String!
    $title: String!
    $body: String!
    $notify_at: timestamptz!
    $is_sent: Boolean!
    $run_id: uuid!
  ) {
    insert_notifications_one(
      object: {
        user_id: $user_id
        org_id: $org_id
        project_id: $project_id
        event_type: $event_type
        title: $title
        body: $body
        notify_at: $notify_at
        is_read: false
        is_cleared: false
        created_by: $user_id
        is_sent: $is_sent
        run_id: $run_id
      }
    ) {
      id
      notify_at
      is_sent
    }
  }
`;

export const GET_ACTIVE_NOTIFICATIONS = gql`
  query GetActiveNotifications(
    $user_id: uuid!
    $org_id: uuid!
    $project_id: uuid!
  ) {
    notifications(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        project_id: { _eq: $project_id }
        is_cleared: { _eq: false }
        notify_at: { _lte: "now()" }
      }
      order_by: { notify_at: desc }
    ) {
      id
      title
      body
      notify_at
      is_read
      event_type
      is_cleared
    }
  }
`;

export const GET_ALL_NOTIFICATIONS = gql`
  query GetActiveNotifications(
    $user_id: uuid!
    $org_id: uuid!
    $project_id: uuid!
  ) {
    notifications(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        project_id: { _eq: $project_id }
        notify_at: { _lte: "now()" }
      }
      order_by: { notify_at: desc }
    ) {
      id
      title
      body
      notify_at
      is_read
      event_type
    }
  }
`;

export const MARK_ALL_READ = gql`
  mutation MarkAllRead($user_id: uuid!, $org_id: uuid!, $project_id: uuid!) {
    update_notifications(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        project_id: { _eq: $project_id }
        is_read: { _eq: false }
      }
      _set: { is_read: true, updated_at: "now()" }
    ) {
      affected_rows
    }
  }
`;

export const MARK_AS_READ = gql`
  mutation MarkAsRead($id: uuid!) {
    update_notifications_by_pk(
      pk_columns: { id: $id }
      _set: { is_read: true, updated_at: "now()" }
    ) {
      id
      is_read
    }
  }
`;

export const MARK_AS_CLEAR = gql`
  mutation MarkAsRead($id: uuid!) {
    update_notifications_by_pk(
      pk_columns: { id: $id }
      _set: { is_cleared: true, updated_at: "now()" }
    ) {
      id
      is_cleared
    }
  }
`;

export const CLEAR_ALL = gql`
  mutation ClearAllNotifications(
    $user_id: uuid!
    $org_id: uuid!
    $project_id: uuid!
  ) {
    update_notifications(
      where: {
        user_id: { _eq: $user_id }
        org_id: { _eq: $org_id }
        project_id: { _eq: $project_id }
        is_cleared: { _eq: false }
      }
      _set: { is_cleared: true, updated_at: "now()" }
    ) {
      affected_rows
    }
  }
`;

export const GET_PENDING_NOTIFICATIONS_QUERY = gql`
  query GetPendingNotifications(
    $userId: uuid!
    $orgId: uuid!
    $projectId: uuid!
  ) {
    notifications(
      where: {
        user_id: { _eq: $userId }
        org_id: { _eq: $orgId }
        project_id: { _eq: $projectId }
        is_sent: { _eq: false }
        notify_at: { _lte: "now()" }
      }
      limit: 5
    ) {
      id
      title
      body
      notify_at
      event_type
      run_id
    }
  }
`;

export const GET_RUN_CHECKLIST_STATUS = gql`
  query GetRunChecklistStatus($runId: uuid!) {
    run_checklist(where: { run_id: { _eq: $runId } }, limit: 1) {
      is_completed
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($id: uuid!) {
    delete_notifications_by_pk(id: $id) {
      id
    }
  }
`;

export const MARK_NOTIFICATION_AS_SENT = gql`
  mutation MarkNotificationAsSent($id: uuid!) {
    update_notifications_by_pk(
      pk_columns: { id: $id }
      _set: { is_sent: true }
    ) {
      id
    }
  }
`;
